import request from "@/utils/request";

// 查询免费抢好货列表
export function getFreeGoodsList() {
  return request({
    url: '/product/free-goods/h5/queryFreeTheme',
    method: 'get'
  })
}

// 查询免费抢好货内容
export function getFreeGoodsDetail() {
  return request({
    url: '/product/free-goods/h5/queryFreeGoods',
    method: 'get',
  })
}



// 选择商品
export function selectedFreeGoods(params) {
  return request({
    url: '/product/free-goods/h5/addFreeGoodsTask',
    method: 'get',
    params
  })
}
// 查询砍价商品
export function queryFreeGoods() {
  return request({
    url: '/product/free-goods/h5/queryTaskProgressBar',
    method: 'get',
  })
}
// 获取额度
export function getTargetPrice() {
  return request({
    url: '/product/free-goods/h5/targetPrice',
    method: 'get'
  })
}
// 帮他人砍价获取商品
export function queryFreeGoodsByTaskid(params) {
  return request({
    url: '/product/free-goods/h5/help/queryTaskProgressBar',
    method: 'get',
    params
  })
}
// 帮人砍价
export function cutFreeGoods(params) {
  return request({
    url: '/product/free-goods/h5/helpCutAKnife',
    method: 'get',
    params
  })
}
// 分享海报图
export function sharePoster(params) {
  return request({
    url: '/product/free-goods/h5/forwardTask',
    method: 'get',
    params
  })
}


